const pathname = location.pathname;
const search = location.search;
if (pathname.includes('products/')){
  //document.getElementById('shopify-block-ARWtHb1RVOVVLeGtyc__mr_point_form_section_ENP68h').remove();
}
document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

$(function(){
  console.log('search:'+search);
  console.log('location.pathname:'+location.pathname);
  /* チェック用URL */

  if(pathname == '/products/000-vintagesake-perpetual-style'){
    if(search.indexOf('gift') > -1){
      $('#MainProductImage').attr('src','//ondosake.com/cdn/shop/files/DSC03591_1.jpg');
      setTimeout(() => {        
        $('a[href="/products/000-vintagesake-perpetual-style?variant=50462283989275"]').removeClass('active');
        $('a[href="/products/000-vintagesake-perpetual-style?variant=50462284022043"]').addClass('active');
      }, 200);
    }
  }
});

// オブジェクトJson整形
(() => {
  if (!document.querySelector('.pre-json')) return;
  class BuetifyPreJson {
    constructor(obj) {
      this.elms = document.querySelectorAll(`${obj.selector}`)
    }
    buetify() {
      [...this.elms].forEach(_elm => {
        const jsonText = _elm.textContent
        const jsonTextParse = JSON.parse(jsonText)
        _elm.textContent = JSON.stringify(jsonTextParse, null, 2)
      })
    }
    init() {
      this.buetify()
    }
  }
  const buetifyPreJson = new BuetifyPreJson({
    selector: '.pre-json',
  })
  buetifyPreJson.init()
})();